import { useParams, useNavigate } from 'react-router-dom';
import { useNotification } from '../../components/Notifications';
import { MessageForm } from './MessageForm';

export function MessageEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const {addNotification} = useNotification();

  return (
    <MessageForm
      messageId={Number(id)}
      onSuccess={() => {
        addNotification('Message updated successfully!', 'success');
        navigate('/messages');
      }}
    />
  );
};
